import React from 'react';
import { Flex } from 'rebass';
import Frame from 'components/Frame';
import CreateJobPostForm from 'modules/JobPosts/components/CreateJobPostForm';

const CreateJobPostPage: React.FC = (): JSX.Element => (
  <Frame>
    <Flex width="100%" flexDirection="column">
      <CreateJobPostForm />
    </Flex>
  </Frame>
);

export default CreateJobPostPage;
